import { queryKeys } from '@/constants/queryKeyFactory'
import { useMutation, useQuery } from '@/hooks/api'
import { ApiResponse, PaginationParams, QueryOptions } from '@/interfaces/api.interface'
import { ILookup } from '@/interfaces/lookups.interface'
import { queryClient } from '@/lib/queryClient'
import { lookupSvc } from '@/services/lookup.service'


export function useLookups(params: PaginationParams = {}, options: QueryOptions = {}) {
  return useQuery<ApiResponse<ILookup[]>>(
    queryKeys.lookups.list(params),
    () => lookupSvc.get<ILookup>({
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      sort: params.sort,
      filter: params.filter,
      searchFilters: params.searchFilters
    }),
    options
  )
}

export function useAllLookups(params: PaginationParams = {}, options: QueryOptions = {}) {
  return useQuery<ApiResponse<ILookup[]>>(
    queryKeys.lookups.all({ ...params }),
    () => lookupSvc.getAll<ILookup>(params),
    options
  )
}

export function useCreateLookup(options: QueryOptions = {}) {
  return useMutation<ApiResponse<ILookup>, ILookup>(
    (data: ILookup) => lookupSvc.create<ILookup>(data),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.lookups.root
        })
      }
    }
  )
}

export function useUpdateLookup(options: QueryOptions = {}) {
  return useMutation<ApiResponse<ILookup>, { id: string; data: ILookup }>(
    ({ id, data }) => lookupSvc.update<ILookup>(id, data),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: queryKeys.lookups.root,
          refetchType: 'active'
        })
      }
    }
  )
}